<div class="opportunity-information-container d-flex flex-column">
    <div class="dialog-body" [formGroup]="linkUnlinkFormGroup">
        <fieldset class="border rounded-3 p-2">
            <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'ESTIMATE' | translate}}</legend>
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-2">{{'ID' | translate}}:</div>
                        <div class="col-md-10 control-align">
                            <mat-form-field appearance="outline">
                            <input matInput formControlName="estimateId" [class.underline-input]="verifiedFields.estimateId">
                            </mat-form-field>
                        <button mat-raised-button color="primary" [disabled]="estimateButtonStates.searchDisabled" (click)="searchEstimate()">...</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{'NAME' | translate}}:</div>
                        <div class="col-md-10">{{ estimateDisplay.name }}
                            <button mat-raised-button class="ml-auto" color="primary" [disabled]="estimateButtonStates.verifyDisabled" (click)="verifyEstimate()">{{'VERIFY' | translate}}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{'SALES_OFFICE' | translate}}:</div>
                        <div class="col-md-10">{{ estimateDisplay.salesOffice }}</div>
                    </div>
                </div>
                <div class="col-md-6">
                @if (!isProspectAccount) {
                    <fieldset class="border rounded-3 p-2">
                        <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'DEPTH_STRUCTURE' | translate}}</legend>
                        <div class="row">
                            <div class="col-md-4">{{'BUSINESS_LINE' | translate}}:</div>
                            <div class="col-md-8">{{ estimateDisplay.businessUnit }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'SEGMENT' | translate}}:</div>
                            <div class="col-md-8">{{ estimateDisplay.segment }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'BUSINESS_HIERARCHY' | translate}}:</div>
                            <div class="col-md-8">{{ estimateDisplay.subSegment }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'GCK_CODE' | translate}}:</div>
                            <div class="col-md-8">{{ estimateDisplay.gckCode }}</div>
                        </div>
                    </fieldset>
                }
                @else{
                    <div class="prospect-account-warning-container">
                        <div class="info-icon-container"><mat-icon>info</mat-icon></div>
                            {{ 'OPP_VERIFY_PROSPECT_ACCOUNT_WARNING' | translate }}
                    </div>
                }
                </div>
            </div>
        </fieldset>
        <fieldset class="border rounded-3 p-2">
            <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'OPPORTUNITY' | translate}}</legend>
            <div class="row align-items-start">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-3">{{'ID' | translate}}:</div>
                        <div class="col-md-9 control-align">
                            <mat-form-field appearance="outline">
                                <input matInput formControlName="opportunityId" [class.underline-input]="verifiedFields.opportunityId">
                            </mat-form-field>
                            <button mat-raised-button color="primary"
                                [disabled]="isOpportunitySearchDisabled"
                                (click)="searchOpportunity()">...</button>
                            <button mat-raised-button color="primary"
                                [disabled]="isOpportunityVerifyDisabled"
                                (click)="verifyOpportunity()">{{'VERIFY' | translate}}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">{{'NAME' | translate}}:</div>
                        <div class="col-md-9">{{ opportunityDisplay.name }}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">{{'SALES_OFFICE' | translate}}:</div>
                        <div class="col-md-9">
                            @if (cultureId === 1) {
                                {{ opportunityDisplay.salesOffice }}
                            } @else {
                                {{ opportunityDisplay.salesOfficeNum }} <em>({{opportunityDisplay.salesOffice}})</em>
                            }
                        </div>
                    </div>
                    @if (canShowFederalFundedSection) {
                    <fieldset class="border rounded-3 p-2">
                        <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'FEDERAL_FUNDED' | translate}}</legend>
                        <div class="row">
                            <div class="col-md-4">{{'GOVERNMENT_ENTITY' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.governmentEntity }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'GOVERNMENT_AGENCY' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.governmentAgency }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'BUY_AMERICAN' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.buyAmerican }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'CONTACT_SCHEDULE' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.contractSchedule }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'DEFENSIVE_PRIORITIES' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.dpas }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'CMMC' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.cmmcLevel }}</div>
                        </div>
                    </fieldset>
                    }
                </div>
                <div class="col-md-6">
                    <fieldset class="border rounded-3 p-2">
                        <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'DEPTH_STRUCTURE' | translate}}</legend>
                        <div class="row">
                            <div class="col-md-4">{{'GCK_CODE' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.gckCode }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'BUSINESS_LINE' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.businessLine }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'SEGMENT' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.segment }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'BUSINESS_HIERARCHY' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.businessHierarchy }}</div>
                        </div>
                    </fieldset>
                    <fieldset class="border rounded-3 p-2">
                        <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'MISC' | translate}}</legend>
                        <div class="row">
                            <div class="col-md-4">{{'EXPECTED_BOOK' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.expectedBook | multilingualDate }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'SELL_AS' | translate}}:</div>
                            <div class="col-md-8">
                                @if (verifiedFields.opportunityId) {
                                {{ opportunityModel?.cEstimateSalePrice | multilingualCurrency }}
                                } @else {
                                {{ opportunityDisplay.sellAs | multilingualCurrency }}
                                }
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'VERTICAL_SALES_TEAM' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.ecs }}</div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">{{'RESTRICTED_TYPE' | translate}}:</div>
                            <div class="col-md-8">{{ opportunityDisplay.restrictedType }}</div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </fieldset>
    </div>
    <div class="dialog-footer  d-flex justify-content-end">
        <button mat-raised-button color="primary"> {{'HELP' | translate}} </button>
        <button mat-raised-button color="primary" [disabled]="!canLinkUnlink" (click)="linkOrUnlinkOpportunity()">{{ linkUnlinkButtonLabel | translate }}</button>
        <button mat-raised-button color="warn" (click)="closeDialog()"> {{'CLOSE' | translate}} </button>
    </div>
</div>